import React from 'react';

export interface IProgressIndicatorBaseProps {
  /* Icon size is driven by availability of `description`. Use `isIconSmall` to override size. */
  isIconSmall?: boolean;
  showStatusIcon?: boolean;
  isCompact?: boolean;
  isMobile?: boolean;
  hidePosition?: boolean;
  t?: (
    /* step position*/
    a: string | number,
    /* total number of steps*/
    b: string | number
  ) => string;
  length?: string | number;
  /* Sheet title on mobile view*/
  sheetTitle?: string;
}

export const ProgressIndicatorContext = React.createContext<IProgressIndicatorBaseProps>({});
